import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["trigger", "content"];

  declare triggerTarget: HTMLElement;
  declare contentTarget: HTMLElement;

  show(event: Event) {
    event.preventDefault();

    this.contentTarget.classList.remove("is-hidden");
    this.triggerTarget.classList.add("is-hidden");

    this.contentTarget.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  hide(event: Event) {
    event.preventDefault();

    this.contentTarget.classList.add("is-hidden");
    this.triggerTarget.classList.remove("is-hidden");
  }
}
